import { Ref, ref } from 'vue'

type LoadingState = [Ref<boolean>, <T = any>(val: Promise<T>) => Promise<T>]

export default () => {
  const isLoading = ref<boolean>(false)

  const loadingWrapper = <T = any>(promise: Promise<T>) => {
    return new Promise<T>(resolve => {
      // 进入loading
      isLoading.value = true
      promise
        .then(res => {
          resolve(res)
        })
        .finally(() => {
          isLoading.value = false
          // 退出loading
        })
    })
  }

  return [isLoading, loadingWrapper] as LoadingState
}
